import withDraft from '@/utils/draftHelper';
import actions from '@/tokens/constants';
import { roleStateToLoad } from './state';

const hideSaveToken = withDraft((draft) => {
  draft.roles.tokens = roleStateToLoad({ roles: draft }).roles.tokens;
});

export default {
  [actions.HIDE_SAVE_TOKEN]: hideSaveToken,
};
